export const GET_NEWSLETTERS_LIST = 'GET_NEWSLETTERS_LIST'
export const GET_NEWSLETTERS_LIST_SUCCESS = 'GET_NEWSLETTERS_LIST_SUCCESS'
export const GET_NEWSLETTERS_LIST_FAILED = 'GET_NEWSLETTERS_LIST_FAILED'

export const CLEAR_NEWSLETTERS_LIST = 'CLEAR_NEWSLETTERS_LIST'
export const REMOVE_NEWS_ITEM = 'REMOVE_NEWS_ITEM'
